const Discounts = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="91"
      height="90"
      viewBox="0 0 91 90"
      fill="none"
      {...props}
    >
      <path
        d="M80 76.9492C80 79.1584 78.2091 80.9492 76 80.9492L35 80.9492C32.7909 80.9492 31 79.1584 31 76.9492L31 32.6583C31 31.4107 31.5821 30.2346 32.5741 29.4779L51.9381 14.7078C53.3134 13.6587 55.2072 13.6125 56.632 14.5933L78.268 29.4864C79.3523 30.2328 80 31.4649 80 32.7813L80 76.9492Z"
        stroke="#333333"
        strokeWidth="3.5"
      />
      <path
        d="M50.0003 16.1847L25.2083 26.2926C24.0693 26.7569 23.2073 27.7195 22.8709 28.9027L12.0936 66.8102C11.4895 68.9351 12.7224 71.1474 14.8473 71.7516L30.8831 .3106"
        stroke="#333333"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <circle
        cx="47.5999"
        cy="45.974"
        r="4.17806"
        stroke="#C89050"
        strokeWidth="3.5"
      />
      <circle
        cx="64.1986"
        cy="61.387"
        r="4.17806"
        stroke="#C89050"
        strokeWidth="3.5"
      />
      <path
        d="M67.5176 42.417L44.0437 65.8909"
        stroke="#C89050"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default Discounts
